module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row hres31x-wrapper",
    attrs: {
      "name": "hres31x"
    }
  }, [_c('div', {
    staticClass: "col-md-6 menu border-bottom-color-skin-dark-10"
  }, [_c('div', {
    staticClass: "panelbutton-mb",
    class: {
      'hidden': _vm.pcDisp
    }
  }, [_c('div', {
    staticClass: "pers-header-btn"
  }, [_c('div', {
    staticClass: "icon-menu fa fa-bars color-skin"
  }), _vm._v(" "), _c('div', {
    staticClass: "label-btn-pers color-skin",
    on: {
      "click": function($event) {
        _vm.toggleMenuMobile()
      }
    }
  }, [_vm._v(" Personal Data Menu ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuMbDisp || _vm.pcDisp),
      expression: "menuMbDisp || pcDisp"
    }],
    staticClass: "show-menu"
  }, [_c('div', {
    staticClass: "rows clearfix"
  }, [_c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(1)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon01.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRRC21P1']['0']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(2)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon02.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['290']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(3)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon03.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['300']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rows clearfix"
  }, [_c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(4)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon04.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['310']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(5)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon05.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['320']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(6)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon06.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['330']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rows clearfix"
  }, [_c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(7)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon07.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['340']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(8)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon08.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['350']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(9)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon09.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['360']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rows clearfix"
  }, [_c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(10)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon10.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['370']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(11)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon11.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['380']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(12)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon12.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['390']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rows clearfix"
  }, [_c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(13)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon13.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['400']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(14)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon14.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['410']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(15)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon15.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['420']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rows clearfix"
  }, [_c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(16)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon16.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['430']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(17)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon17.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['440']) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(18)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon18.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['450']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rows clearfix"
  }, [_c('div', {
    staticClass: "col-xs-4 pers-mb-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(19)
      }
    }
  }, [_c('img', {
    staticClass: "mb-btn-icon",
    attrs: {
      "src": require("../../assets/img/personal-data/profile-icon19.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-btn-label"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['460']) + "\n            ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.menuMbDisp || _vm.pcDisp),
      expression: "!menuMbDisp || pcDisp"
    }],
    staticClass: "header bg-color-skin-dark-10"
  }, [_c('div', {
    staticClass: "image"
  }, [(_vm.pathImage) ? _c('img', {
    attrs: {
      "src": _vm.pathImage
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.pathImage) ? _c('img', {
    attrs: {
      "src": require("static/images/employee/no_image.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.descCodemid) + "  ")]), _vm._v(" "), _c('div', {
    staticClass: "underline"
  }), _vm._v(" "), _c('div', {
    staticClass: "corp"
  }, [_vm._v(_vm._s(_vm.descCodcomp))]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_vm.descCodpos))])])]), _vm._v(" "), _c('div', {
    staticClass: "panelbutton",
    class: {
      'hidden': !_vm.pcDisp
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-1",
    class: {
      'active': _vm.generalDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(1)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRRC21P1']['0']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-2",
    class: {
      'active': _vm.privateDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(2)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['290']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-3",
    class: {
      'active': _vm.employDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(3)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['300']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-4",
    class: {
      'active': _vm.incomeDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(4)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['310']) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-5",
    class: {
      'active': _vm.taxDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(5)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['320']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-6",
    class: {
      'active': _vm.educateDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(6)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['330']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-7",
    class: {
      'active': _vm.expDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(7)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['340']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-8",
    class: {
      'active': _vm.parentDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(8)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['350']) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-9",
    class: {
      'active': _vm.coupleDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(9)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['360']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-10",
    class: {
      'active': _vm.childDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(10)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['370']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-11",
    class: {
      'active': _vm.guarantorDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(11)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['380']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-12",
    class: {
      'active': _vm.assetDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(12)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['390']) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-13",
    class: {
      'active': _vm.talentDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(13)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['400']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-14",
    class: {
      'active': _vm.trainingDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(14)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['410']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-15",
    class: {
      'active': _vm.goodDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(15)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['420']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-16",
    class: {
      'active': _vm.changeDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(16)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['430']) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-17",
    class: {
      'active': _vm.fileDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(17)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['440']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-18",
    class: {
      'active': _vm.personrefDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(18)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers"
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['450']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 box-btn-pers"
  }, [_c('div', {
    staticClass: "btn-pers-19",
    class: {
      'active': _vm.etcDataActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePage(19)
      }
    }
  }, [_c('div', {
    staticClass: "label-btn-pers",
    class: {
      'label-btn-pers-active': _vm.etcDataActive
    }
  }, [_vm._v("\n              " + _vm._s(_vm.labels[_vm.app.nowLang]['HRES31XC1']['460']) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.menuMbDisp || _vm.pcDisp),
      expression: "!menuMbDisp || pcDisp"
    }],
    staticClass: "col-md-6 clear-padding"
  }, [_c('hres31x-topic', {
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab1,
      "pcDisp": _vm.pcDisp,
      "page": _vm.page,
      "toggleMenuMobile": _vm.toggleMenuMobile,
      "onArrowLeft": _vm.onArrowLeft,
      "onArrowRight": _vm.onArrowRight
    }
  }), _vm._v(" "), _c('v-touch', {
    on: {
      "swipeleft": _vm.onSwipeLeft,
      "swiperight": _vm.onSwipeRight
    }
  }, [_c('hres31x-tab1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.generalDataActive),
      expression: "generalDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab1,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.privateDataActive),
      expression: "privateDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab2,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.employDataActive),
      expression: "employDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab3,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.incomeDataActive),
      expression: "incomeDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab4,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab5', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.taxDataActive),
      expression: "taxDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab5,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab6', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.educateDataActive),
      expression: "educateDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab6,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab7', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expDataActive),
      expression: "expDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab7,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab8', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.parentDataActive),
      expression: "parentDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab8,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab9', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.coupleDataActive),
      expression: "coupleDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab9,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab10', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.childDataActive),
      expression: "childDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab10,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab11', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guarantorDataActive),
      expression: "guarantorDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab11,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab12', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.assetDataActive),
      expression: "assetDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab12,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab13', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.talentDataActive),
      expression: "talentDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab13,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton,
      "receivedHres31xdataDetailTab13Popup": _vm.receivedHres31xdataDetailTab13Popup,
      "detailTab13Popup": _vm.detailTab13Popup,
      "tab13PopupColumn": _vm.columns[_vm.app.nowLang].detailTab13Popup
    }
  }), _vm._v(" "), _c('hres31x-tab14', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.trainingDataActive),
      expression: "trainingDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab14,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab15', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goodDataActive),
      expression: "goodDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab15,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab16', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeDataActive),
      expression: "changeDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab16,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab17', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileDataActive),
      expression: "fileDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab17,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab18', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.personrefDataActive),
      expression: "personrefDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab18,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  }), _vm._v(" "), _c('hres31x-tab19', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.etcDataActive),
      expression: "etcDataActive"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.app.nowLang,
      "labels": _vm.labels[_vm.app.nowLang],
      "detail": _vm.detailTab19,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "triggerButton": _vm.triggerButton
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d8f02ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/component.vue
// module id = 3554
// module chunks = 1